import customApi from '../components/api/customApi'
import alertUtils from './alertUtils'
// import swUserApi from '../components/api/swUserApi'

/**
 * 用户工具类
 */
export default class customUtils extends alertUtils {
  /**
   *  获取当前应用下可以看到的所有接口
   * @param id  表单ID
   * @param options 下拉选项
   */
  static getDataInterface(id, options) {
    customApi
      .getDataInterface(id)
      .then(response => {
        if (response) {
          console.log('options', options)
          options.push(...response)
        }
      })
      .catch(() => {
        this.alertError('接口列表查询错误', true)
      })
  }

  /**
   * 获取接口 详细
   * @param id  接口ID
   */
  static getDataInterfaceInfoInput(
    id,
    serviceObj,
    serviceArr,
    controlObj,
    deepCopy
  ) {
    const service = {}
    if (serviceArr.length) {
      console.log(11111111111)
      const flag = serviceArr.some(item => {
        return id === item.resultInfo.id
      })
      if (flag) {
        serviceArr.forEach(item => {
          if (
            id === item.resultInfo.id &&
            !item.resultInfo.template &&
            item.type === 'select'
          ) {
            // 处理
            serviceObj.fields = item.resultInfo.keys.split(',')
            serviceObj.resultInfo = item.resultInfo
            serviceObj.testResult = item.testResult
            serviceObj.params = item.params
            serviceObj.variables = item.variables
            controlObj.isControl = false
          }
          if (
            id === item.resultInfo.id &&
            item.resultInfo.template &&
            item.type === 'cascader'
          ) {
            serviceObj.fields = item.fields
            serviceObj.resultInfo = item.resultInfo
            serviceObj.testResult = item.testResult
            serviceObj.params = item.params
            serviceObj.variables = item.variables
            controlObj.isControl = true
          }
        })
        const a = serviceArr.pop()
        serviceArr.push(a)
      }
      if (!flag) {
        Promise.all([
          customApi.getDataInterfaceInfo(id),
          customApi.requestInterface(id, null),
        ]).then(([response1, response2]) => {
          if (response1) {
            service.resultInfo = response1
            serviceObj.resultInfo = response1
            const keyStr = response1.keys
            const templateString = response1.template
            if (templateString) {
              const templateStr = JSON.parse(templateString)
              const newStr = deepCopy(templateStr)
              const newStr1 = newStr.substring(0, newStr.length - 1).split(',')
              service.fields = Array.from(new Set(newStr1))
              serviceObj.fields = Array.from(new Set(newStr1))
              // console.log("service.fields",service.fields);
            } else if (!templateString && keyStr) {
              const keys = keyStr.split(',')
              if (keys && keys.length > 0) {
                service.fields = keys
                serviceObj.fields = keys
              }
            }
            const paramsObj = JSON.parse(response1.params)
            const params = []
            if (paramsObj) {
              for (const key in paramsObj) {
                params.push({ name: key, value: paramsObj[key] })
              }
              service.params = params
            }
            const variables = JSON.parse(response1.variables)
            service.variables = variables
            serviceObj.variables = variables
            if (response1.template) {
              service.type = 'cascader'
            } else {
              service.type = 'select'
            }
          }
          if (response2) {
            service.testResult = response2
            serviceObj.testResult = response2
          }
          serviceArr.push(service)
          serviceArr.forEach(item => {
            if (id === item.resultInfo.id) {
              serviceObj.fields = item.resultInfo.template
                ? item.fields
                : item.resultInfo.keys.split(',')
              console.log('this.service.fields', serviceObj.fields)
              serviceObj.resultInfo = item.resultInfo
              serviceObj.testResult = item.testResult
              serviceObj.params = item.params
              serviceObj.variables = item.variables
              controlObj.isControl = !!item.resultInfo.template
              console.log('isControl', controlObj.isControl)
            }
          })
        })
      }
    } else {
      console.log(2222222222)
      Promise.all([
        customApi.getDataInterfaceInfo(id),
        customApi.requestInterface(id, null),
      ]).then(([response1, response2]) => {
        if (response1) {
          service.resultInfo = response1
          serviceObj.resultInfo = response1
          const keyStr = response1.keys
          const templateString = response1.template
          if (templateString) {
            const templateStr = JSON.parse(templateString)
            const newStr = deepCopy(templateStr)
            const newStr1 = newStr.substring(0, newStr.length - 1).split(',')
            service.fields = Array.from(new Set(newStr1))
            serviceObj.fields = Array.from(new Set(newStr1))
            // console.log("service.fields",service.fields);
          } else if (!templateString && keyStr) {
            const keys = keyStr.split(',')
            if (keys && keys.length > 0) {
              service.fields = keys
              serviceObj.fields = keys
            }
          }
          const paramsObj = JSON.parse(response1.params)
          const params = []
          if (paramsObj) {
            for (const key in paramsObj) {
              params.push({ name: key, value: paramsObj[key] })
            }
            service.params = params
          }
          const variables = JSON.parse(response1.variables)
          service.variables = variables
          serviceObj.variables = variables
          if (response1.template) {
            service.type = 'cascader'
          } else {
            service.type = 'select'
          }
        }
        if (response2) {
          service.testResult = response2
          serviceObj.testResult = response2
        }
        serviceArr.push(service)
        serviceArr.forEach(item => {
          if (id === item.resultInfo.id) {
            serviceObj.fields = item.resultInfo.template
              ? item.fields
              : item.resultInfo.keys.split(',')
            console.log('this.service.fields', serviceObj.fields)
            serviceObj.resultInfo = item.resultInfo
            serviceObj.testResult = item.testResult
            serviceObj.params = item.params
            serviceObj.variables = item.variables
            // toggleControl(item.resultInfo.template))
            controlObj.isControl = !!item.resultInfo.template
            console.log('isControl', controlObj.isControl)
          }
        })
      })
    }
  }

  /**
   * 获取接口 详细
   * @param id  接口ID
   */
  static getDataInterfaceInfo(id, service) {
    customApi
      .getDataInterfaceInfo(id)
      .then(response => {
        if (response) {
          service.resultInfo = response
          const keyStr = response.keys
          if (keyStr) {
            const keys = keyStr.split(',')
            if (keys && keys.length > 0) {
              service.fields = keys
            }
          }
          const paramsObj = JSON.parse(response.params)
          const params = []
          if (paramsObj) {
            for (const key in paramsObj) {
              params.push({ name: key, value: paramsObj[key] })
            }
            service.params = params
          }
          const variables = JSON.parse(response.variables)
          service.variables = variables
        }
      })
      .catch(() => {
        this.alertError('接口详细查询错误', true)
      })
  }

  /**
   *  根据接口ID，查询接口数据
   * @param id 接口ID
   */
  static requestInterface(id, service) {
    customApi
      .requestInterface(id, null)
      .then(response => {
        if (response) {
          service.testResult = response
        }
      })
      .catch(() => {
        this.alertError('接口数据查询错误', true)
      })
  }
}
